import React from 'react';

const ServicesContent = ({ scenario, onComplete }) => {
  return (
    <div className="h-full bg-white p-4">
      <div className="text-sm text-gray-600">Services management interface</div>
    </div>
  );
};

export default ServicesContent;

